import React from 'react';
import styles from './ScheduleErrorScreen.module.css';

interface ScheduleErrorScreenProps {
  error?: Error;
  className?: string;
}

const ScheduleErrorScreen: React.FC<ScheduleErrorScreenProps> = ({
  error,
  className = '',
}) => {
  return (
    <div className={`${styles['schedule-error-screen']} ${className}`}>
      <div className={styles['error-container']}>
        <div className={styles['error-icon']}>
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#f56565" strokeWidth="2"/>
            <path d="m15 9-6 6" stroke="#f56565" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="m9 9 6 6" stroke="#f56565" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <h2 className={styles['error-title']}>Schedule Configuration Issue</h2>

        <p className={styles['error-message']}>
          There is an issue with the schedule configuration that is preventing
          HallHero from displaying your dashboard.
        </p>

        <div className={styles['error-actions']}>
          <p className={styles['contact-message']}>
            Please contact your school administrator to resolve this issue.
          </p>

          <button
            className={styles['refresh-button']}
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>

        {process.env.NODE_ENV === 'development' && error && (
          <details className={styles['error-details']}>
            <summary>Technical Details (Development Only)</summary>
            <pre className={styles['error-stack']}>
              {error.message}
              {error.stack && `\n\n${error.stack}`}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
};

export default ScheduleErrorScreen;
